import { trimmedStringSchema } from "@/schemas"
import { z } from "zod"

import { contactDialogTypes } from "./contact-dialog.types"

const messageMaxLength = 500

export const contactSchema = z
  .object({
    // Contact messages are capped above defaultMaxLength.
    message: trimmedStringSchema.max(messageMaxLength).min(1),
    type: z.enum(contactDialogTypes),
  })
  // Why partial? To allow the confirmPassword validation to display without having to complete the entire form.
  // See https://github.com/colinhacks/zod/issues/479#issuecomment-854822386
  .partial()

export type ContactSchema = z.infer<typeof contactSchema>
